var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#paint0_linear_1120_863)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 15C22.1533 15 21.581 15.2431 21.159 15.6759C20.7371 16.1087 20.5 16.6957 20.5 17.3077V18.0769H15.25C14.6533 18.0769 14.081 18.3201 13.659 18.7528C13.2371 19.1856 13 19.7726 13 20.3846V22.5138L24.421 25.6369C24.8004 25.7405 25.1996 25.7405 25.579 25.6369L37 22.5138V20.3846C37 19.7726 36.7629 19.1856 36.341 18.7528C35.919 18.3201 35.3467 18.0769 34.75 18.0769H29.5V17.3077C29.5 16.6957 29.2629 16.1087 28.841 15.6759C28.419 15.2431 27.8467 15 27.25 15H22.75ZM22.75 16.5385H27.25C27.4489 16.5385 27.6397 16.6195 27.7803 16.7638C27.921 16.908 28 17.1037 28 17.3077V18.0769H22V17.3077C22 17.1037 22.079 16.908 22.2197 16.7638C22.3603 16.6195 22.5511 16.5385 22.75 16.5385Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 32.6923C13 33.3043 13.2371 33.8913 13.659 34.3241C14.081 34.7569 14.6533 35 15.25 35H34.75C35.3467 35 35.919 34.7569 36.341 34.3241C36.7629 33.8913 37 33.3043 37 32.6923V24L25.1935 27.2262C25.0667 27.2609 24.9333 27.2609 24.8065 27.2262L13 24V32.6923Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1120_863",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#446DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F5DFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.2b3f283f2c528e80b864b33b77c730a1.svg";
export { ForwardRef as ReactComponent };